import {GET_PROVIDER_MOVEMENT_PROVIDER_MOVEMENT,GET_BALANCE_AGE_PROVIDER_MOVEMENT,RESET_PROVIDER_MOVEMENT} from '../../../../constants/ActionTypes'
import {zeroPad,currencyFormat} from '../../../../util/DaFrameword'
import moment from 'moment'

var initialState = {
    TableData:[],
    Data:[],
    footerBalance:{
        value1:0,
        value2:0,
        value3:0,
        value4:0,
        display1 :"Balance 1",
        display2 :"Balance 2",
        display3 :"Balance 3",
        display4 :"Balance 4",
    }
}

function ProviderMovement (state=initialState,action){

    switch (action.type) {
        
        case GET_PROVIDER_MOVEMENT_PROVIDER_MOVEMENT:

            const Request=action.payload.data;
            var UltimateData=[];
            const OnlyPending=action.payload.OnlyPending;

            console.log(action.payload,"CONSU")

            Request.forEach((element) => {
            var Balance=element.cxpTransactionDetailValue;

            UltimateData.push({
                Type: element.abbreviationCode,
                Document: zeroPad(element.number,element.length),
                Date: moment (new Date(element.date)).format('DD/MM/YYYY'),
                Debit: element.cxpTransactionDetailValue,
                DebitDisplay:currencyFormat(element.cxpTransactionDetailValue),
                Credit: 0.00,
                CreditDisplay:"",
                BalanceDisplay:currencyFormat((OnlyPending)?element.pendindDebit :element.cxpTransactionDetailValue),
                Balance:element.cxpTransactionDetailValue,
                Concept: element.concept
            })

                if (element.pagos.length>0 && !OnlyPending){
                    element.pagos.forEach((pago)=>{
                        Balance=Balance-pago.cxpDetailValue;
                        UltimateData.push({
                            Type: pago.abbreviationCode,
                            Document: zeroPad(pago.number,pago.length),
                            Date: moment (new Date(pago.date)).format('DD/MM/YYYY'),
                            Debit: 0.00,
                            DebitDisplay:"",
                            Credit:pago.cxpDetailValue,
                            CreditDisplay:currencyFormat(pago.cxpDetailValue),
                            BalanceDisplay:currencyFormat(Balance),
                            Balance:Balance,
                            Concept: pago.detailconcept
                        })
                    })
                }
            });

            return{
                ...state,
                Data:action.payload,
                TableData:UltimateData,
                footerBalance:action.payload.footerBalance,
            }
            case GET_BALANCE_AGE_PROVIDER_MOVEMENT:
                var Balance=action.payload
                return {
                    ...state,
                    footerBalance:{
                        
                        ...state.footerBalance,
                        display1:`Balance (${Balance.beginDay1} - ${Balance.endDay1})`,
                        display2:`Balance (${Balance.beginDay2} - ${Balance.endDay2})`,
                        display3:`Balance (${Balance.beginDay3} - ${Balance.endDay3})`,
                        display4:`Balance (Más de ${Balance.endDay3})`,

                    }
                }
            
            case RESET_PROVIDER_MOVEMENT:
                return{
                    ...initialState,
                    footerBalance:{
                        ...state.footerBalance,
                        value1:0,
                        value2:0,
                        value3:0,
                        value4:0
                    }
                }
        default:
            return state;
    }
}

export default ProviderMovement;